import { BadgeVariants } from '@morressier/alembic';
import { useNavigate } from 'react-router-dom';
import { useReviewData } from 'src/contexts/ReviewDataProvider';
import HighlightItem from '../editorial/PeerReview/HighlightItem';
import { faPeopleArrows } from '@fortawesome/pro-regular-svg-icons';

export const CoReviewHighlight = () => {
  const navigate = useNavigate();
  const { otherCoReviewer, review, submissionContext } = useReviewData();
  const coReview = review.caseData.coReview;

  const inviteCoReviewer = () => {
    navigate(`/app/reviews/${review.id}/coreview-invite`);
  };

  let heading: string = '';
  let context: string = '';
  let variant: BadgeVariants = 'attention';

  const coReviewerDisplayName =
    otherCoReviewer?.firstName && otherCoReviewer?.lastName
      ? `${otherCoReviewer.firstName} ${otherCoReviewer.lastName}`
      : otherCoReviewer?.email;

  const isCoReviewEnabled = submissionContext.config.isCoReviewEnabled;

  if (!isCoReviewEnabled || !review.allowCoReviewInvite) {
    return null;
  }

  if (!coReview) {
    (heading = 'Add Co-Reviewer'),
      (context = 'Invite a colleague to help assess this Submission.');
  }

  if (coReview?.status === 'accepted') {
    heading = 'Submission In Co-Review';
    context = `${coReviewerDisplayName} is co-reviewing this Submission with you. Both of you have full editting access, and will receive equal credits`;
    variant = 'success';
  }

  if (coReview?.status === 'pending') {
    (heading = 'Awaiting Co-Reviewer'),
      (context = `${coReview.coReviewer.email} was invited to Co-Review this Submission but hasn't accepted your invitation yet.`);
  }

  if (coReview?.status === 'declined') {
    heading = 'Co-Review Rejected';
    context = `${coReviewerDisplayName} rejected your invitation to co-review this Submission.`;
    variant = 'caution';
  }

  return (
    <HighlightItem
      icon={faPeopleArrows}
      variant={variant}
      heading={heading}
      context={context}
      // If there is no status, it means coReviewer isn't invited yet, so we show the button
      {...(!coReview?.status
        ? {
            buttonText: 'Invite',
            buttonOnClick: inviteCoReviewer
          }
        : {})}
    />
  );
};
